export const updateTranslatedField = <T, K extends keyof T>(
  item: T,
  field: K,
  lang: string,
  value: string,
): T => {
  return {
    ...item,
    [field]: {
      ...((item[field] as unknown as Record<string, string> | null) || {}),
      [lang]: value,
    },
  };
};
